import React from 'react';
import { getPrimary, getSecondary } from '../../styles/colors';
import { AlertConfirm, BasicButton, TextInput } from '../../UI';

const ModalTranslate = ({
	translate,
	setLocalState,
	item,
	name,
}) => {
	const [newTranslationMain, setNewTranslationMain] = React.useState(false);
	const [newItem, setNewItem] = React.useState(item);

	React.useEffect(() => {
		setNewItem(item);
	}, [item]);

	return (
		<div style={{ marginLeft: '1em' }}>
			<BasicButton
				color='white'
				text={'Editar traducción'}
				onClick={() => setNewTranslationMain(true)}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold',
					height: '30px',
					width: '145px',
				}}
			/>
			<AlertConfirm
				open={newTranslationMain}
				title={`Añadir traducciones de ${name}`}
				buttonAccept={translate.save}
				buttonCancel={translate.cancel}
				cancelAction={() => {
					setNewItem(item);
					setNewTranslationMain(false);
				}}
				acceptAction={() => {
					setLocalState({
						...newItem
					});
					setNewTranslationMain(false);
				}}
				requestClose={() => setNewTranslationMain(true)}
				bodyStyle={{ minWidth: '60vw' }}
				bodyText={
					<div>
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Clave de traducción
							</span>
							<TextInput
								floatingText={'Label'}
								onChange={event => {
									setNewItem({
										...newItem,
										label: event.nativeEvent.target.value
									});
								}}
								value={newItem.label}
							/>
							<div>
								Traducción: {translate[newItem.label] ? translate[newItem.label] : '*No funciona la key o está mal escrita'}
							</div>
						</div>
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
							marginTop: '4px'
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Traducción personalizada por idioma
							</span>
							{Object.keys(newItem.text).map(key => (
								<TextInput
									key={key}
									floatingText={key}
									value={newItem.text[key]}
									onChange={event => {
										setNewItem({
											...newItem,
											text: {
												...newItem.text,
												[key]: event.nativeEvent.target.value
											}
										});
									}
									}
								/>
							))}
						</div>

					</div>
				}
			/>
		</div>
	);
};


export default ModalTranslate;

